


export const BookingHistory_START = 'BookingHistory_START';
export const BookingHistory_END = 'BookingHistory_END';
export const BookingHistory_ERROR = 'BookingHistory_ERROR';
export const BookingHistory_SUCCESS = 'BookingHistory_SUCCESS';
export const BookingHistory_FAIL = 'BookingHistory_FAIL';